import posthog from "posthog-js";
import { readDevFlagOverride } from "@/hooks/useFlag";

/* PostHog experiment "Abonnement e-mail checkout v1": control = the login checkout from before #1194 (buttons go to
   /aanmelden), test = the e-mail checkout on /abonnement. Only anonymous web visitors take part; the app always keeps
   the login checkout and signed-in users keep the account checkout. Force a variant outside production with
   ?ph-flag-abonnement-email-checkout-v1=control (or =test). */
export const ABONNEMENT_EMAIL_CHECKOUT_FLAG = "abonnement-email-checkout-v1";
export const LOGIN_CHECKOUT_VARIANT = "control";
const FLAG_WAIT_MS = 1500;

/* True when this purchase goes through the login checkout. The flag is read only when an anonymous web visitor starts
   a purchase, so only those visitors count as exposed. Waits briefly for flags on a fresh page load; without flags
   (blocked, timeout) the visitor keeps the e-mail checkout. */
export function usesLoginCheckout(native: boolean, isLoggedIn: boolean | null): Promise<boolean> {
  if (native) return Promise.resolve(true);
  if (isLoggedIn === true) return Promise.resolve(false);
  const override = readDevFlagOverride(ABONNEMENT_EMAIL_CHECKOUT_FLAG);
  if (override !== undefined) return Promise.resolve(override === LOGIN_CHECKOUT_VARIANT);
  return new Promise((resolve) => {
    let done = false;
    let unsubscribe: (() => void) | undefined;
    const finish = () => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      unsubscribe?.();
      resolve(posthog.getFeatureFlag(ABONNEMENT_EMAIL_CHECKOUT_FLAG) === LOGIN_CHECKOUT_VARIANT);
    };
    const timer = setTimeout(finish, FLAG_WAIT_MS);
    try {
      unsubscribe = posthog.onFeatureFlags(finish);
      if (done) unsubscribe();
    } catch {
      finish();
    }
  });
}
